export default {
  computed: {
    $isLoggedIn () {
      return !!this.$store.state.auth.token
    },

    $user () {
      return this.$store.state.auth.user
    },
  },

  methods: {
    $notify (color, message, options = {}) {
      this.$store.commit('notifications/add', {
        ...options,
        color,
        id: (new Date()).toISOString(),
        message,
      })
    },
  },
}
